import Modal from 'src/utilities/UILibrary/Feedback/Modal/Modal';
import styled from 'styled-components';
import { breakpoints } from 'src/utilities/UIStyles/variables/breakpoints';

export const ComposedModalWrapper = styled(Modal)`
  .modal-header {
    img {
      width: 5rem;
    }
  }

  @media (min-width: ${breakpoints.desktop}) {
    .modal-header {
      img {
        width: 7rem;
      }
    }
  }
`;
